import styled, { keyframes } from "styled-components"

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`

export const Skeleton = styled.div<{ $height?: string }>`
  height: ${({ $height }) => $height ?? "1rem"};
  border-radius: ${({ theme }) => theme.radius.sm};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.color.skeletonBase} 25%,
    ${({ theme }) => theme.color.skeletonHighlight} 50%,
    ${({ theme }) => theme.color.skeletonBase} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s linear infinite;
`
